const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "test\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77.64,24.56a19.09,19.09,0,0,0-7.58,1.57A25.28,25.28,0,0,0,44.71,3.5c-14,0-25.45,11.17-25.45,24.9A24.24,24.24,0,0,0,19.7,33,14.4,14.4,0,1,0,17.17,61.5h.5a1.5,1.5,0,1,0,0-3h-.5a11.38,11.38,0,1,1,0-22.75,11.91,11.91,0,0,1,4.08.73,1.5,1.5,0,0,0,1.95-1.85,21.43,21.43,0,0,1-.94-6.24c0-12.08,10.07-21.9,22.45-21.9s22.45,9.83,22.45,21.86c0,0,0,.14,0,.18a1.5,1.5,0,0,0,2.27,1.29,16.11,16.11,0,0,1,8.22-2.26,15.46,15.46,0,1,1,.55,30.91l-.24,0H72.09a1.5,1.5,0,1,0,0,3h6.15a1.47,1.47,0,0,0,.35,0,18.45,18.45,0,0,0-.95-36.89Z",
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.94,77.94,64.5,87.38V43a1.5,1.5,0,0,0-3,0V87.38l-9.44-9.44a1.5,1.5,0,1,0-2.12,2.12l12,12a1.5,1.5,0,0,0,2.12,0l12-12a1.5,1.5,0,0,0-2.12-2.12Z",
    id: "id_102",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.06,53.94l-12-12a1.5,1.5,0,0,0-2.12,0l-12,12a1.5,1.5,0,0,0,2.12,2.12l9.44-9.44V91a1.5,1.5,0,0,0,3,0V46.62l9.44,9.44a1.5,1.5,0,0,0,2.12-2.12Z",
    id: "id_103",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.59,24.52a1.5,1.5,0,0,0,2.81-1A16.61,16.61,0,0,0,45,12.5a1.5,1.5,0,0,0,0,3A13.6,13.6,0,0,1,57.59,24.52Z",
    id: "id_104",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.f204e1acfd7b21c823fa68b60348f80d.svg";
export { ForwardRef as ReactComponent };